import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../lib/firebase";
import Loader from "../components/Loader";
import Admin from "./Admin";
import NotFound from "../pages/NotFound";

const GetAdmin = () => {
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (authUser) => {
      if (authUser) {
        const userDocRef = doc(db, "bit", authUser.uid);
        const userDoc = await getDoc(userDocRef);

        if (userDoc.exists()) {
          const userData = userDoc.data();
          setUserRole(userData.role || null);
        } else {
          console.log("No user document found");
          setUserRole(null);
        }
      } else {
        setUserRole(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [auth]);

  if (loading) {
    return <Loader />;
  }

  // Render content based on user role
  if (userRole === "admin") {
    // If user role is 'admin', show Admin component
    return <Admin />;
  }

  // If user role is not 'admin', show NotFound component
  return <NotFound />;
};

export default GetAdmin;
